// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"OZ-z","sponsoredTooltipWrapper":"PZ-z","sponsoredTooltip":"QZ-z","newCard":"RZ-z"};